const viewerZIndex = ELEMENT.Image.components.ImageViewer.computed.viewerZIndex;

function getDom(selector) {
  if (!selector) return document.body;
  let toDom = null;
  if (selector.constructor === HTMLDivElement) {
    toDom = selector;
  } else if (dsf.isString(selector)) {
    toDom = document.querySelector(selector);
  } else if (dsf.isFunction(selector)) {
    toDom = selector();
  }
  return toDom || document.body;
}

function moveTo(el) {
  let toDom = getDom(el.__vScreenTo);
  if (el.__vScreenWarpDom && toDom == el.__vScreenWarpDom.parentNode) return;
  if (!el.__vScreenComment) {
    el.__vScreenComment = document.createComment('v-screen-comment');
    el.parentNode.insertBefore(el.__vScreenComment, el);
  }
  let warpDom = document.createElement('div');
  el.__vScreenClass && warpDom.setAttribute('class', el.__vScreenClass);
  warpDom.style.position = 'absolute';
  warpDom.style.top = '0';
  warpDom.style.bottom = '0';
  warpDom.style.left = '0';
  warpDom.style.right = '0';
  warpDom.style.overflow = 'auto';
  warpDom.style.zIndex = viewerZIndex.call({zIndex: 0});
  warpDom.appendChild(el);
  let overflow = toDom.style.overflow;
  toDom.style.overflow = 'hidden';
  toDom.appendChild(warpDom);
  dsf.dispatchResize();
  if (el.__vScreenWarpDom) {
    let oldParentNode = el.__vScreenWarpDom.parentNode;
    if (el.__vScreenToDomOverflow) {
      oldParentNode.style.overflow = el.__vScreenToDomOverflow;
    }
    oldParentNode.removeChild(el.__vScreenWarpDom);
  }
  el.__vScreenToDomOverflow = overflow;
  el.__vScreenWarpDom = warpDom;
}

function reset(el) {
  if (!el.__vScreenComment) return;
  let warpDom = el.__vScreenWarpDom;
  let parentNode = el.__vScreenComment.parentNode;
  parentNode.insertBefore(el, el.__vScreenComment);
  parentNode.removeChild(el.__vScreenComment);
  warpDom.parentNode.style.overflow = el.__vScreenToDomOverflow;
  warpDom.parentNode.removeChild(warpDom);
  el.__vScreenWarpDom = undefined;
  el.__vScreenComment = undefined;
  el.__vScreenToDomOverflow = undefined;
  dsf.dispatchResize();
}

export default {
  install(Vue) {
    /**
     * v-screen-value 值为boolean
     *  true 表示全屏开启
     *  false 表示全屏关闭
     */
    Vue.directive("screen-value", {
      inserted(el, { value }){
        dsf.setObjAttr(el, '__vScreenValue', value);
        value && moveTo(el);
      },
      update(el, { value }) {
        el.__vScreenValue = value;
        value ? moveTo(el) : reset(el);
      },
      unbind(el) {
        reset(el);
      },
    });
    /**
     * v-screen-to 值为 string、HTMLElement、Function
     *  表示全屏移动到该元素下
     */
    Vue.directive("screen-to", {
      inserted(el, { value }){
        dsf.setObjAttr(el, '__vScreenTo', value);
      },
      update(el, { value }, vnode) {
        el.__vScreenTo = value;
        el.__vScreenValue && moveTo(el);
      }
    });
    /**
     * v-screen-class 值为string
     *  表示全屏的class
     */
    Vue.directive("screen-class", {
      inserted(el, { value }){
        dsf.setObjAttr(el, '__vScreenClass', value);
      },
      update(el, { value }) {
        el.__vScreenClass = value;
        if (el.__vScreenValue && el.__vScreenWarpDom) {
          el.__vScreenWarpDom.setAttribute('class', value);
        }
      }
    });
  }
}